module.exports = __webpack_public_path__ + "static/media/home_icon.f6825c6f.svg";